import BaseVariantImages from './BaseVariantImages'

const VariantImages = {
  ...BaseVariantImages,
  // Logos
  Logo: require('./img/variants/emt/logo.svg'),
  LogoPrimary: require('./img/variants/emt/logoPrimary.png'),
  LogoSitter: require('./img/variants/emt/logoSitter.svg'),
  LogoSitterWhite: require('./img/variants/emt/logoSitterWhite.svg'),
  LogoSitterWhiteDark: require('./img/variants/emt/logoSitterWhiteDark.svg'),
  LogoSitterWhiteFull: require('./img/variants/emt/logo-supersitters-white.svg'),
  LogoSitterBlackFull: require('./img/variants/emt/logo-supersitters-black.svg'),
  // Stores
  GooglePlay: require('./img/variants/emt/googlePlay.svg'),
  AppStore: require('./img/variants/emt/appStore.svg'),
  // Medias
  Medias: require('./img/variants/emt/medias.svg'),
}

export default VariantImages
